import { getOrderId, ocapiClient } from '@vista-digital/occ-domain'
import { getLogger } from '../services'

export async function cancelOrder(id?: string) {
    const logger = getLogger('Util')

    logger.value.trace('Starting cancelOrder')

    const orderId = id ?? getOrderId()

    if (orderId) {
        try {
            logger.value.debug('Attempting to cancel order', { orderId })
            await ocapiClient.instance.v1.orders.cancel(orderId)
            logger.value.info('Order successfully cancelled', { orderId })
        } catch {
            logger.value.warn('Failed to cancel order', { orderId })
        }
    } else {
        logger.value.debug('No order id was found when trying to cancel order')
    }

    logger.value.trace('Finished cancelOrder')
}
